import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title1: 'Bigger Loan',
    title2: 'Exciting Surprise',
    title3: 'Gifts',
    title4: 'Discount',
    title5: 'Quick Approval',
    title6: 'Coming Soon',
    desc1: 'Keep paying in time, you will get a bigger loan up to Rp 50.000.000!',
    desc2: 'Complete tasks, earn points, have exciting surprise!',
    desc3: `You can get many kinds of gifts!`,
    desc4: 'Get a discount when exchange for stuff.',
    desc5: 'You will get approved quicker.',
    desc6: 'Download Kredit Pintar app to get more benefits.',
  },
  id: {
    title1: 'Pinjaman Lebih Besar',
    title2: 'Kejutan Seru',
    title3: 'Hadiah',
    title4: 'Diskon',
    title5: 'Persetujuan Cepat',
    title6: 'Segera Hadir',
    desc1: 'Terus bayar tepat waktu, Anda akan mendapat pinjaman lebih besar hingga Rp 50.000.000!',
    desc2: 'Selesaikan tugas, dapatkan poin dan menangkan kejutan seru!',
    desc3: 'Anda bisa mendapatkan berbagai macam hadiah!',
    desc4: 'Dapatkan diskon saat menukar barang.',
    desc5: 'Persetujuan Cepat hanya untuk Anda.',
    desc6: 'Unduh aplikasi Kredit Pintar untuk mendapatkan lebih banyak keuntungan.',
  },
})

const GuideBenefit = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/guide/guide1.png',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/images/guide/guide2.png',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/images/guide/guide3.png',
      title: t('title3'),
      desc: t('desc3'),
    },
    {
      img: '/images/guide/guide4.png',
      title: t('title4'),
      desc: t('desc4'),
    },
    {
      img: '/images/guide/guide5.png',
      title: t('title5'),
      desc: t('desc5'),
    },
    {
      img: '/images/guide/guide6.png',
      title: t('title6'),
      desc: t('desc6'),
    },
  ]
  return (
    <FeatureStyle>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 100} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <LazyLoad>
                    <Image src={item.img} alt={item.title} width={360} height={360} placeholder="empty" quality={85} />
                  </LazyLoad>
                </div>
                <div className="subtitle">{item.title}</div>
                <div className="des">{item.desc}</div>
              </div>
            </Reveal>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <Image
                        src={item.img}
                        alt={item.title}
                        width={280}
                        height={280}
                        placeholder="empty"
                        quality={85}
                      />
                    </LazyLoad>
                  </div>
                  <div className="subtitle">{item.title}</div>
                  <div className="des">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </FeatureStyle>
  )
}

export default GuideBenefit

const FeatureStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    img {
      width: 100%;
      height: 100%;
    }
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;
      .item {
        width: 280px;
        height: 380px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
        text-align: left;
        .img {
          width: 100%;
        }
        .subtitle {
          padding-top: 20px;
          font-size: 20px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
        }
        .des {
          margin-top: 6px;
          font-size: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 24px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 120px 150px 0;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 360px;
        height: 520px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        margin-bottom: 32px;
        text-align: left;
        .img {
          width: 100%;
          height: 360px;
        }
        .subtitle {
          padding-top: 32px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #333333;
          line-height: 32px;
        }
        .des {
          padding-top: 14px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
        }
      }
    }
  }
`
